import { render, staticRenderFns } from "./EditRequisiteModal.vue?vue&type=template&id=3c0762d6&"
import script from "./EditRequisiteModal.vue?vue&type=script&lang=js&"
export * from "./EditRequisiteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports